import { io, Socket } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000';
class SocketService {
    private socket: Socket | null = null;

    connect() {
        if (this.socket?.connected) return;

        const token = localStorage.getItem('jwtToken');

        this.socket = io(SOCKET_URL, {
            auth: {
                token: token,
                type: 'admin'
            },
            transports: ['websocket'],
            reconnection: true,
        });

        this.socket.on('connect', () => {
            console.log('[Socket] Connected:', this.socket?.id);
        });

        this.socket.on('connect_error', (err: any) => {
            console.error('[Socket] Connection Error:', err);
        });
    }

    joinRoom(chatRoomId: number | string) {
        if (!this.socket) this.connect();
        this.socket?.emit('join_room', { chatRoomId });
    }

    leaveRoom(chatRoomId: number | string) {
        if (!this.socket) return;
        this.socket.emit('leave_room', { chatRoomId });
    }

    onMessageReceived(callback: (message: any) => void) {
        if (!this.socket) return;
        this.socket.on('receive_message', (payload: any) => {
            console.log('[Socket] Message Received:', payload);
            callback(payload);
        });
    }

    offMessageReceived() {
        this.socket?.off('receive_message');
    }

    /** Generic emit for client-pushed events (e.g. 'chat:typing', 'chat:read'). */
    emit(event: string, payload?: any) {
        if (!this.socket) this.connect();
        this.socket?.emit(event, payload);
    }

    /** Generic subscription for server-pushed events (e.g. 'safety:sos'). */
    on(event: string, callback: (payload: any) => void) {
        if (!this.socket) this.connect();
        this.socket?.on(event, callback);
    }

    off(event: string, callback?: (payload: any) => void) {
        if (callback) this.socket?.off(event, callback);
        else this.socket?.off(event);
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
        }
    }
}

export const socketService = new SocketService();